export function projectChoices({ projects, query, pickedId, cap = 50 }) {
  const choices = Array.isArray(projects) ? projects : [];
  const needle = String(query ?? '').trim().toLowerCase();
  const hits = choices
    .filter((project) => !needle || String(project?.project_name ?? '').toLowerCase().includes(needle))
    .slice(0, cap);

  // Keep search results capped at 50 for a manageable picker.
  // Always list the linked project so an existing link never appears blank.
  if (pickedId && !hits.some((project) => project.id === pickedId)) {
    const picked = choices.find((project) => project.id === pickedId);
    if (picked) return [picked, ...hits];
  }

  return hits;
}
